import repository from './repsitory'

const resource = '/credomatic'

export default {
    getOrderToRevoke (id) {
        return repository.get(`${resource}/revoke/${id}`)
    },
}
